<template>
  <div style="float: right; text-align: right">
    <div>
      <v-btn :to="computedLink">
        <v-icon>chevron_left</v-icon>Bill diary
      </v-btn>
      <v-btn @click="downloadBill(false)">
        <v-icon>picture_as_pdf</v-icon>Original
      </v-btn>
      <v-btn @click="downloadBill(true)">
        <v-icon>picture_as_pdf</v-icon>File copy
      </v-btn>
    </div>
    <div v-if="$keycloak.hasRealmRole('billadmin')">
      <v-btn @click="calculateTotal" small>Calculate totals</v-btn>
      <v-btn @click="removeDuplicates" small>Remove duplicates</v-btn>
      <v-btn @click="updateBreakdown" small>Update breakdown</v-btn>
    </div>
    <p>
      <a @click="updateBillTracker">Visible on tracker</a>
      <span>:</span>
      <span :class="booleanStrongStyle(bill.tracker)">{{
        booleanConverter(bill.tracker)
      }}</span>
    </p>
    <v-btn :to="{ name: 'billEmail', params: { id: bill.id } }"
      >Email bill</v-btn
    >
    <template v-if="bill.archived">
      <v-chip color="red" text-color="white">Deleted</v-chip>
      <a @click="updateBillArchived" v-if="$keycloak.hasRealmRole('root')"
        >Undelete</a
      >
    </template>
  </div>
</template>

<script>
import { format, parseISO } from "date-fns";
import { booleanStrongStyle, booleanConverter } from "@/util/helpers";
export default {
  name: "RightPanel",
  props: ["editDisabled", "bill", "customdate"],
  computed: {
    computedLink() {
      if (!this.bill) {
        return undefined;
      }
      return {
        name: "billDiary",
        query: { date: format(parseISO(this.customdate), "yyyyMMdd") }
      };
    }
  },
  methods: {
    booleanStrongStyle,
    booleanConverter,
    updateBillArchived() {
      if (confirm("Are you sure?")) {
        this.$emit("updateArchived");
      }
    },
    updateBillTracker() {
      this.$emit("updateTracker");
    },
    downloadBill(filecopy) {
      window.open(
        `${process.env.VUE_APP_CT_URL}/cors/admin/bill/bills/${this.$route.params.id}/pdf/${filecopy}`,
        "_blank"
      );
    },
    calculateTotal() {
      this.$emit("updateTotal");
    },
    async removeDuplicates() {
      this.$emit("removeDuplicates");
    },
    async updateBreakdown() {
      this.$emit("updateBreakdown");
    }
  }
};
</script>

<style>
</style>
